export default {
  date: 'November 8, 2025',
  title: 'AI Getfloorplan Now Creates Offices — From Floor Plans to Photorealistic 3D Visualizations',
  description: 'Getfloorplan’s AI designs office spaces, coworking hubs, and business centers in 2D, 3D, and 360° — fast, professional, and completely online.',
  metaTitle: 'AI Getfloorplan — Office Projects in 2D and 3D: Floor Plans, 360° Tours, and Photorealistic Renderings',
  metaDescription: 'AI Getfloorplan creates office spaces, coworking hubs, and business centers in 2D and 3D. The AI generates floor plans, 360° virtual tours, and photorealistic renderings — fast, professional, and completely online.',
  id: 'getfloorplan-offices',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        AI Getfloorplan is expanding its capabilities! The platform now creates not only residential but also commercial spaces — offices, coworking hubs, and business centers. Artificial intelligence automatically generates 2D and 3D floor plans, 360° virtual tours, and photorealistic renderings.
        Everything is done online — fast and professionally.
      </p>
      <p>
        <b>New office design styles include:</b>
      </p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>
          <b>Office Standard</b> — functional, well-balanced workspaces for offices and meeting rooms. Accurate lighting, proportions, and details make it ideal for corporate brochures and websites.
        </li>
        <li class='margin-none'>
          <b>Office Elegance</b> — a premium style featuring soft lighting, elegant textures, and a modern aesthetic. Realistic 3D renderings help developers and agencies boost conversions and speed up sales.
        </li>
        <li class='margin-none'>
          <b>Office Dark</b> — a sleek, tech-inspired workspace with deep tones and minimalist geometry. Ready-to-use visuals in just 24 hours — simply upload your plan and get professional results without delay.
        </li>
        <li class='margin-none'>
          <b>Office Classic</b> — bright, ergonomic office layouts designed for comfort and productivity.
        </li>
      </ul>
      <p>AI Getfloorplan is your all-in-one tool for creating 2D and 3D visualizations, 360° tours, and photorealistic renderings of office spaces. Fast. Professional. Online.</p>
    </div>
  ),
  thumb: 'news/66.webp',
};
